import React from 'react';
import withStyles from 'react-jss';
import styles from './styles';

const ButtonSubmit = ({ classes, children }) => (
	<button className={[classes.root, classes.primary].join(' ')} type="submit">{children}</button>
);

export default withStyles(styles)(ButtonSubmit);
